module.exports = __webpack_public_path__ + "img/no-positions-dark.a6c4c1bc.png";